export default "__VITE_ASSET__CS_LL7sC__";